import { render } from "./SectionSelectionModal.vue?vue&type=template&id=363a761d&scoped=true"
import script from "./SectionSelectionModal.vue?vue&type=script&lang=ts"
export * from "./SectionSelectionModal.vue?vue&type=script&lang=ts"

import "./SectionSelectionModal.vue?vue&type=style&index=0&id=363a761d&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-363a761d"

export default script